import version from './../version';

jQuery($ => {
    const initMap = function () {
        const $maps = $('.map');

        if ($maps.length) {
            require.ensure([], require => {
                require([
                    'scriptjs/dist/script'
                ], ($script) => {
                    // load google maps
                    $script('https://maps.googleapis.com/maps/api/js?key=AIzaSyBH8KexzV8B-Y8o-Hr6_PbP5qQdZgeJJP8', () => {
                        // loop over map container
                        $maps.each(function (i, container) {
                            let $container = $(container),
                                map = new google.maps.Map($container.find('.map__iframe')[0]),
                                markers = [],
                                bounds = new google.maps.LatLngBounds();

                            /* eslint-disable */
                            map.set('styles', [
                                {
                                    "featureType": "administrative",
                                    "elementType": "labels.text.fill",
                                    "stylers": [
                                        {
                                            "color": "#444444"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "landscape",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "color": "#f2f2f2"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "saturation": -100
                                        },
                                        {
                                            "lightness": 45
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road.highway",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "simplified"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road.arterial",
                                    "elementType": "labels.icon",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "transit",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "water",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "color": "#79a1b8"
                                        },
                                        {
                                            "visibility": "on"
                                        }
                                    ]
                                }
                            ]);
                            /* eslint-enable */

                            // add placemarks to the map
                            $container.find('.map__list__item div').each(function (i, item) {
                                let $item = $(item),
                                    alternativePinColor = $item.data('alternative-pin-color'),
                                    pinFile = alternativePinColor ? 'assets/img/placemarks/marker_alternative.png' : 'assets/img/placemarks/marker.png',
                                    position = new google.maps.LatLng($item.data('lat'), $item.data('lng'));

                                markers.push(position);

                                version(pinFile).then(function (pin) {
                                    let marker = new google.maps.Marker({
                                        map,
                                        position,
                                        title: $item.data('title'),
                                        cursor: 'pointer',
                                        icon: {
                                            size: new google.maps.Size(256, 256),
                                            scaledSize: new google.maps.Size(36, 36),
                                            origin: new google.maps.Point(0, 0),
                                            anchor: new google.maps.Point(24, 43),
                                            url: pin
                                        }
                                    });

                                    marker.addListener('click', () => {
                                        $item.find('a')[0].click();
                                    });
                                });
                            });

                            // set the bounds based on the markers
                            markers.forEach(position => { bounds.extend(position); });

                            map.fitBounds(bounds);
                        });
                    });
                });
            }, 'map');
        }
    };

    window.initMap = initMap;
    initMap();
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/map.js